interface ISegmented<T extends string | number> {
    options: { value: T, label: string }[]
    value: T | undefined
    onChange: (value: T) => void
    ariaLabel: string
    className?: string
}

export const Segmented = <T extends string | number>({ options, value, onChange, ariaLabel, className = '' }: ISegmented<T>) => (
    <div role='group' aria-label={ariaLabel} className={`inline-flex rounded-xl bg-canvas-deep p-1 ${className}`}>
        {options.map((option) => {
            const active = option.value === value
            return <button
                key={option.value}
                type='button'
                aria-pressed={active}
                onClick={() => onChange(option.value)}
                className={`h-11 flex-1 whitespace-nowrap rounded-lg px-3 text-sm font-medium lg:h-9 lg:[@media(pointer:coarse)]:h-11 transition-colors duration-150 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-focus/50 ${active ? 'bg-surface text-ink shadow-rim' : 'text-ink-muted hover:text-ink'}`}>
                {option.label}
            </button>
        })}
    </div>
)
